import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.approve.alert.title',
        defaultMessage: `You have <b>{transactionCount, plural,
             one {# transaction}
              other {# transactions}}</b> that need to be confirmed`,
    },
    showAll: {
        id: 'cards.approve.alert.show_all',
        defaultMessage: 'Show all',
    },
})
